import React from 'react';
import { useTranslation } from 'react-i18next';
import SweetAlert2 from 'react-sweetalert2';


type SAlertIcon = 'warning' | 'error' | 'success' | 'info' | 'question'

interface Props {
  msg?: string,
  HtmlMsg?: any,
  show: boolean, 
  showDenyButton?: boolean,
  confirmBtnText?: string, 
  cancelBtnText?: string, 
  denyButtonText?: string,
  confirmBtnBsStyle?: string,
  cancelBtnBsStyle?: string, 
  denyBtnBsStyle?: string,
  title: string, 
  onConfirm: () => void,
  onCancel: () => void,
  onDeny?: () => void,
  showCancel?: boolean,
  icon?: SAlertIcon,
}
// Callers pass Bootstrap style names ("danger", "secondary"). Those were being handed
// to SweetAlert2's confirmButtonColor, which wants a CSS colour — an unrecognised value
// is dropped, so every alert fell back to SweetAlert2's own purple/grey and looked
// nothing like the rest of the app. Map them onto the button classes the app's own
// modals use instead, and turn SweetAlert2's styling off so those classes apply.
const BUTTON_CLASSES: Record<string, string> = {
    primary: 'btn btn-primary',
    danger: 'btn btn-danger',
    success: 'btn btn-success',
    // The app's modals dismiss with .btn-cancel, not a grey secondary.
    secondary: 'btn btn-cancel',
    cancel: 'btn btn-cancel',
    warning: 'btn btn-cancel',
};

const buttonClass = (style: string | undefined, fallback: string) =>
    BUTTON_CLASSES[(style || '').toLowerCase()] || fallback;

const SAlert: React.FC<Props> = ({
    msg, HtmlMsg, show, showDenyButton, confirmBtnText, cancelBtnText, denyButtonText, confirmBtnBsStyle, cancelBtnBsStyle, denyBtnBsStyle, title, onConfirm, onCancel, onDeny, showCancel, icon
}) => {
    const { t } = useTranslation('components.SAlert');
    return (
      <SweetAlert2
        show={show}
        icon={icon || 'warning'}
        showCancelButton={showCancel || false}
        showDenyButton={showDenyButton || false}
        allowOutsideClick={false}
        allowEscapeKey={false}
        confirmButtonText={confirmBtnText || t('confirm_default', 'Yes')}
        cancelButtonText={cancelBtnText || t('cancel_default', 'No')}
        denyButtonText={denyButtonText || t('deny_default', "Don't Save")}
        buttonsStyling={false}
        customClass={{
            popup: 'salert-popup',
            title: 'salert-title',
            htmlContainer: 'salert-text',
            actions: 'salert-actions',
            confirmButton: buttonClass(confirmBtnBsStyle, 'btn btn-primary'),
            cancelButton: buttonClass(cancelBtnBsStyle, 'btn btn-cancel'),
            denyButton: buttonClass(denyBtnBsStyle, 'btn btn-outline-secondary'),
        }}
        title={title}
        text={msg}
        html={HtmlMsg}
        // onConfirm={onConfirm}
        onResolve={(result:any)=>{
            if (result.isDenied && onDeny) {
                onDeny();
            }
            if (result.isDismissed) {
                onCancel();
            }
            if (result.isConfirmed) {
                onConfirm();
            }
        }}
        onError={onCancel}
        focusCancel={false}
        backdrop={true}
      />
    );
}

export default SAlert;
